import { Button, PrimaryButton, Stack } from '@fluentui/react';
import * as React from 'react';
import { IProfileContact } from '../../../Models/Profile/IProfileContact';
import { BillingForm } from '../../Identity/InvoiceContact/BillingForm';
import { InvoiceContactForm } from '../../Identity/InvoiceContact/InvoiceContactForm';

interface INewOrderStepInvoiceProps {
    isLoading: boolean;
    profileInfo: IProfileContact;
    propertyChanged: (key: string, value: any) => void;
    goToStep: (step: number) => void;
    isAuth: boolean;
    goBack: () => void;
}


export const NewOrderStepInvoice: React.FunctionComponent<INewOrderStepInvoiceProps> = (props) => {
    const [isValid, setIsValid] = React.useState(false);
    const [isValidBilling, setIsValidBilling] = React.useState(false);
    const goToNextStep = () => {
        props.goToStep(4);
    }

    //const goToPrevStep = () => {
    //    if (props.isAuth === true) {
    //        props.goToStep(1);
    //    }
    //    else {
    //        props.goToStep(2);
    //    }
    //}
 

    return (<Stack >
        <h2>Kdopak to vlastně zaplatí ? </h2>

        <Stack styles={{ root: { maxWidth: 800 } }}>
            <InvoiceContactForm isValid={setIsValid} isValidBilling={setIsValidBilling} contactInfo={props.profileInfo} isLoading={props.isLoading} propertyChanged={props.propertyChanged} />

            <Stack horizontal wrap verticalAlign="center" horizontalAlign="center" tokens={{ childrenGap: 10 }} styles={{ root: { paddingTop: 20 } }}>
                <Button text="< Zpět" onClick={props.goBack} />
                <PrimaryButton disabled={!(isValid && isValidBilling)} text="Pokračovat >" onClick={goToNextStep} />
        </Stack>

        </Stack>
    </Stack>)
}
